import React from "react";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import axios from "axios";
import API from "../helpers/api";
import swal from "sweetalert";
import { getClientUserAddList } from "../Actions/ClientManagementAPI";
import { Multiselect } from "multiselect-react-dropdown";

let user = JSON.parse(localStorage.getItem("currentUser"));

class FleetManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            fleetManagerList: [],
            fleetManagerListRole: [],
            fleetManagerIdsList:[],
            CommonArray:[]
        }
         this.addFleetManager = this.addFleetManager.bind(this);
       }
      
       static getDerivedStateFromProps(nextProps, prevState) {
        const { fleetManagerlist } = nextProps;
        
        }

        componentDidMount() {
            this.props.dispatch({ type: 'SubBannerTitle', data: "Client Management" });
          var FinalArray= this.props?.fleetManagerlist;
          var FinalArray1=this.props.TechSuperintendentlist;
          var FinalArray2=this.props.TechExecutivelist;
          this.state.CommonArray=this.props.fleetManagerArraylist;
           if (FinalArray && FinalArray.length > 0) {
            FinalArray.map((val, index) => {
              this.state.CommonArray = this.state.CommonArray.filter(x => x.id !== val.clientUserId);
              this.setState({})
            })
          }
            if (FinalArray1 && FinalArray1.length > 0) {
              FinalArray1.map((val, index) => {
                this.state.CommonArray = this.state.CommonArray.filter(x => x.id !== val.clientUserId);
                this.setState({})
              })
            }
              if (FinalArray2 && FinalArray2.length > 0) {
                FinalArray2.map((val, index) => {
                  this.state.CommonArray = this.state.CommonArray.filter(x => x.id !== val.clientUserId);
                  this.setState({})
                })
              }
           }
    hideSidePanel() {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push("/Home/Management/ClientAdd");
    }

    onSelectChange(item) {
       this.state.fleetManagerIdsList = [];
        this.state.fleetManagerList = item;
        if (item && item.length > 0) {
          item.map((val, index) => {
            let shipnames = this.props.fleetManagerArraylist.filter(x => x.id == val.id);
            if (shipnames && shipnames.length > 0) {
              this.state.fleetManagerIdsList.push(shipnames[0].id);
            }
          })
        }
        this.setState({});
      }
    
      onRemoveChange(item) {
        this.state.fleetManagerIdsList = [];
        this.state.fleetManagerList = item;
        if (item && item.length > 0) {
          item.map((val, index) => {
            let shipnames = this.props.fleetManagerArraylist.filter(x => x.id == val.id);
            if (shipnames && shipnames.length > 0) {
              this.state.fleetManagerIdsList.push(shipnames[0].id);
            }
          })
        }
        this.setState({});
      }

    addFleetManager() {
        const { dispatch } = this.props;
          if (this.state.fleetManagerIdsList !== [] ) {
            let FinalArray=[];
           /*  let FinalArray1=[];
            let FinalArray2=[]; */
            var CommonArray=[]
            if(this.props.fleetManagerlist && this.props.fleetManagerlist.length){
              this.props.fleetManagerlist.map((item)=>{
                if(item.clientUserId){
                 FinalArray.push(item.clientUserId)
                }
             })
            }
          
           /*  if(this.props.TechExecutivelist){
              this.props.TechExecutivelist.map((item)=>{
                if(item.clientUserId){
                 FinalArray1.push(item.clientUserId)
                }
             })
            } */
          /*  if(this.props.TechSuperintendentlist){
            this.props.TechSuperintendentlist.map((item)=>{
              if(item.clientUserId){
               FinalArray2.push(item.clientUserId)
              }
           })
           } */
         

        /*     if(FinalArray.length>0 &&FinalArray1.length>0&& FinalArray2.length>0 ){
             CommonArray=[...FinalArray,...this.state.fleetManagerIdsList,...FinalArray1,...FinalArray2]
            }else if(FinalArray.length>0 &&FinalArray1.length>0){
                CommonArray=[...FinalArray,...this.state.fleetManagerIdsList,...FinalArray1]
            }else if(FinalArray.length>0&& FinalArray2.length>0){
              CommonArray=[...FinalArray,...this.state.fleetManagerIdsList,...FinalArray2]
            }else if(FinalArray1.length>0&& FinalArray2.length>0){
              CommonArray=[...FinalArray1,...this.state.fleetManagerIdsList,...FinalArray2]
            }else if(FinalArray1.length>0){
              CommonArray=[...FinalArray1,...this.state.fleetManagerIdsList]
            }else if(FinalArray2.length>0){
              CommonArray=[...this.state.fleetManagerIdsList,...FinalArray2]
            } */
            if(FinalArray.length>0){
              CommonArray=[...FinalArray,...this.state.fleetManagerIdsList]
            }else{
              CommonArray=[...this.state.fleetManagerIdsList]
            }
          
            dispatch(getClientUserAddList(CommonArray.toString(),"fleetmanager"))
             this.hideSidePanel()
            } else {
            swal('Error!', 'Email is mandatory', 'warning');
        }
    }

    render() {
        const { fleetManagerArraylist } = this.props;
        return (
            <div className="full-height">
                <div className="resource-list-auth-date row pt-3 ">
                    <div className='w-100'>
                        <div className="panel-box search-filter-box">
                            <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                onClick={() => this.hideSidePanel()}
                            >
                                &larr; Return
                            </button>
                            <div className="card mt-2 MM-card-header" style={{ backgroundColor: "white" }}>
                                <div className="card-body" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                    <h5 className="card-title ml-2 mt-2" style={{ color: "092a51" }}>Fleet Managers</h5>
                                </div>
                            </div>
                            <div className="row search-filter-box">
                               
                                <div className="col-lg-6">
                                    <label className="form-label">Email</label><br></br>
                                    <Multiselect
                      options={ this.state.CommonArray.length>0? this.state.CommonArray:fleetManagerArraylist}
                      displayValue="name"
                      showArrow={true}
                      isObject={true}
                      style={{
                        option: {"margin-right": 0,display: "block","font-weight": "normal",
                        },
                        chips: { "background-color": "#1a3464" },
                      }}
                      onSelect={(item) => this.onSelectChange(item)}
                      onRemove={(item) => this.onRemoveChange(item)}
                      selectedValues={this.state.fleetManagerList}
                      placeholder={this.state.fleetManagerList && this.state.fleetManagerList.length? "": "Select"}
                      closeIcon="cancel"
                    />
                                </div>
                               
                            </div>
                            <div className="row">
                                <div className="col-lg-12 search-filter-box">
                                    <div className="search-btn-col" style={{ textAlign: 'end' }}>
                                        <button className="btn btn-primary text-uppercase txtside-btn txtht-btn blue" type="submit" onClick={() => this.addFleetManager()}> Add </button>
                                        <button className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3" type="button" onClick={() => this.hideSidePanel()}> Cancel </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        fleetManagerlist: state.MasterScreenReducer.fleetManagerlist || [],
        fleetManagerArraylist: state.MasterScreenReducer.FleetManagerArrayList,
        TechExecutivelist:state.MasterScreenReducer.TechExecutivelist || [],
        TechSuperintendentlist:state.MasterScreenReducer.TechSuperintendentlist || [],
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FleetManager));